'use strict';

angular.module('ClinicApp').controller('ModalClinicUpdateInsurance', function($scope, $q, $modalInstance, appointment, inNetwork, ClinicService, DoctorService) {
  $scope.appointment = appointment;
  $scope.inNetwork = inNetwork;

  $scope.updateInsurancePlan = function(doctorId) {
    if ($scope.inNetwork) {
      DoctorService.removeInsurancePlan(
        doctorId,
        $scope.appointment.insuranceData.providerPlan,
        $scope.appointment.insuranceData.provider,
      );
    } else {
      DoctorService.addInsurancePlan(
        doctorId,
        $scope.appointment.insuranceData.providerPlan,
        $scope.appointment.insuranceData.provider,
      );
    }
  };

  $scope.updateAll = function() {
    // Dont need to be syncronous
    return ClinicService.getClinicDoctors($scope.appointment.provider.clinic.id).then(function(doctors) {
      var promises = [];
      _.forEach(doctors, function(doctor) {
        promises.push($scope.updateInsurancePlan(doctor.id));
      });
      promises.push($modalInstance.close(true));
      return $q.all(promises);
    });
  };

  $scope.updateOne = function() {
    // Dont need to be syncronous
    $scope.updateInsurancePlan($scope.appointment.provider.doctor.id);
    $modalInstance.close(true);
  };

  $scope.updateNone = function() {
    $modalInstance.close(false);
  };

});
